// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QqbYq","loginBlock":"Header_loginBlock__Brc82"};